import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  `,
  content: css`
    width: 520px;
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;
    padding: 16px 24px;
    min-width: 520px;
  `,
  title: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
    width: 100%;
  `,
  text: css`
    margin-top: 16px;
    text-align: center;
  `,
  selectWrapper: css`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  `,
  select: css`
    z-index: 3;
    width: calc(520px - 48px);

    & > div {
      overflow: unset;
    }
  `,
  createJobWrapper: css`
    display: flex;
    justify-content: right;
    width: 100%;
    padding: 8px 0 12px;
    & > div {
      margin-right: 16px;
    }
  `,
  createJob: css`
    margin-left: unset;
  `,
  endIcon: css`
    display: flex;
    align-items: center;
    gap: 5px;
  `,
  editIconButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    margin-left: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  footerMessageContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
  `,
  indeedCreditsSection: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  indeedCreditsRow: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  `,
  indeedPickers: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  `,
  indeedJobPicker: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  `,
  indeedInlineError: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${theme.colors.tertiary.red[50]};
  `,
  indeedQualityErrorLink: ({ theme }) => css`
    border: 0;
    padding: 0;
    background: transparent;
    color: ${theme.colors.tertiary.red[50]};
    cursor: pointer;
    font: inherit;
    text-decoration: underline;
  `,
  loader: css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 472px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
